// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/usr/src/app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/usr/src/app/src/layouts/UserLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "login",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/usr/src/app/src/pages/user/login'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/info",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/usr/src/app/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "log",
        "path": "/info/device/log",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__LogManagement' */'/usr/src/app/src/pages/EquipmentManagement/LogManagement'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'/usr/src/app/src/layouts/SecurityLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/usr/src/app/src/layouts/BasicLayout'), loading: LoadingComponent}),
        "authority": [
          "superadmin",
          "server",
          "agency",
          "agencysub",
          "platformadmin",
          "business",
          "auditor",
          "ps",
          "ps_auditor"
        ],
        "routes": [
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Index' */'/usr/src/app/src/pages/Index'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "home",
            "icon": "desktop",
            "authority": [
              "agency",
              "agencysub",
              "server",
              "superadmin",
              "platformadmin"
            ],
            "path": "/home",
            "routes": [
              {
                "name": "accountInfo",
                "path": "/home/account_info",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__AccountInfo' */'/usr/src/app/src/pages/Home/AccountInfo'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "server",
                  "superadmin",
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "notification",
                "path": "/home/notification",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Notification' */'/usr/src/app/src/pages/Home/Notification'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "server",
                  "superadmin",
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "personalCenter",
                "path": "/home/personal_center",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__PersonalCenter' */'/usr/src/app/src/pages/Home/PersonalCenter'), loading: LoadingComponent}),
                "authority": [
                  "superadmin"
                ],
                "exact": true
              },
              {
                "name": "password",
                "path": "/home/password",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Password' */'/usr/src/app/src/pages/Home/Password'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "server",
                  "superadmin",
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "country",
                "path": "/home/country",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home__Country' */'/usr/src/app/src/pages/Home/Country'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "product",
            "icon": "dashboard",
            "path": "/product",
            "authority": [
              "platformadmin"
            ],
            "routes": [
              {
                "name": "itemLib",
                "path": "/product/item_lib",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__ItemLib' */'/usr/src/app/src/pages/Product/ItemLib'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "itemLibCategory",
                "path": "/product/item_lib_category",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__ItemLibCategory' */'/usr/src/app/src/pages/Product/ItemLibCategory'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "itemLibBrand",
                "path": "/product/item_lib_brand",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__ItemLibBrand' */'/usr/src/app/src/pages/Product/ItemLibBrand'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "itemTemplate",
                "path": "/product/item_template",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__ItemTemplate' */'/usr/src/app/src/pages/Product/ItemTemplate'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "itemLibApplyWithPagination",
                "path": "/product/item_lib_apply",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__ItemLibApplyWithPagination' */'/usr/src/app/src/pages/Product/ItemLibApplyWithPagination'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "goodsMultiPackagingAudit",
                "path": "/Product/goods_multi_packaging_audit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__GoodsMultiPackagingAudit' */'/usr/src/app/src/pages/Product/GoodsMultiPackagingAudit'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin",
                  "agency"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "equipmentManagement",
            "icon": "sliders",
            "authority": [
              "agency",
              "agencysub",
              "platformadmin",
              "server"
            ],
            "path": "/equipment_management",
            "routes": [
              {
                "name": "deviceList",
                "path": "/equipment_management/devices",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__Devices' */'/usr/src/app/src/pages/EquipmentManagement/Devices'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "deviceByServer",
                "path": "/equipment_management/devices_server",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DevicesByServer' */'/usr/src/app/src/pages/EquipmentManagement/DevicesByServer'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "details",
                "hideInMenu": true,
                "path": "/equipment_management/devices/details",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__Details' */'/usr/src/app/src/pages/EquipmentManagement/Details'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "server"
                ],
                "exact": true
              },
              {
                "name": "adBank",
                "path": "/equipment_management/ad_bank",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__AdBank' */'/usr/src/app/src/pages/EquipmentManagement/AdBank'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "advertisingManagement",
                "path": "/equipment_management/advertising_management",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__AdvertisingManagement' */'/usr/src/app/src/pages/EquipmentManagement/AdvertisingManagement'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "relocationHistory",
                "path": "/equipment_management/relocation_history",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceRelocationHistory' */'/usr/src/app/src/pages/EquipmentManagement/DeviceRelocationHistory'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "equipmentFailure",
                "path": "/equipment_management/equipment_failure",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentFailure' */'/usr/src/app/src/pages/EquipmentManagement/EquipmentFailure'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "deviceListUpdateApp",
                "path": "/equipment_management/list_update_device",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DevicesPlatformAdmin' */'/usr/src/app/src/pages/EquipmentManagement/DevicesPlatformAdmin'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "deviceType",
                "path": "/equipment_management/device_type",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceType' */'/usr/src/app/src/pages/EquipmentManagement/DeviceType'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "deviceModel",
                "path": "/equipment_management/device_model",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceModel' */'/usr/src/app/src/pages/EquipmentManagement/DeviceModel'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "deviceTypeTemplate",
                "path": "/equipment_management/device_typetemplate",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceTypeTemplate' */'/usr/src/app/src/pages/EquipmentManagement/DeviceTypeTemplate'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "outstock",
                "path": "/equipment_management/outstock",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__Outstock' */'/usr/src/app/src/pages/EquipmentManagement/Outstock'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "deviceInventory",
                "path": "/equipment_management/equipmentManagement/DeviceInventory",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceInventory' */'/usr/src/app/src/pages/EquipmentManagement/DeviceInventory'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "groupLine",
                "path": "/equipment_management/groupLine",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__GroupLine' */'/usr/src/app/src/pages/EquipmentManagement/GroupLine'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "groupLinePoint",
                "path": "/equipment_management/groupLinePoint",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__GroupLinePoint' */'/usr/src/app/src/pages/EquipmentManagement/GroupLinePoint'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "deviceQrCodeManagement",
                "path": "/equipment_management/deviceQrCodeManagement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__DeviceQrCodeManagement' */'/usr/src/app/src/pages/EquipmentManagement/DeviceQrCodeManagement'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "firmware",
                "path": "/equipment_management/firmware",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__Firmware' */'/usr/src/app/src/pages/EquipmentManagement/Firmware'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "wxMpAdsManagement",
                "path": "/equipment_management/wxMpAdsManagement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__WxMpAdsManagement' */'/usr/src/app/src/pages/EquipmentManagement/WxMpAdsManagement'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "adminManualConfig",
            "icon": "setting",
            "path": "/admin_manual_config",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AdminManualConfig' */'/usr/src/app/src/pages/AdminManualConfig'), loading: LoadingComponent}),
            "authority": [
              "platformadmin"
            ],
            "exact": true
          },
          {
            "name": "commodityManagement",
            "icon": "shop",
            "path": "/commodity_management",
            "authority": [
              "agency",
              "agencysub"
            ],
            "routes": [
              {
                "name": "commodityList",
                "path": "/commodity_management/commodity_list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__GoodsList' */'/usr/src/app/src/pages/Goods/GoodsList'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "commodityAdd",
                "path": "/commodity_management/commodity_list/add",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__Add' */'/usr/src/app/src/pages/Goods/Add'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "commodityPrice",
                "path": "/commodity_management/commodity_price",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__GoodsPrice' */'/usr/src/app/src/pages/Goods/GoodsPrice'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "itemLib",
                "path": "/commodity_management/item_lib",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__ItemLib' */'/usr/src/app/src/pages/Goods/ItemLib'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "itemLibApply",
                "path": "/commodity_management/item_lib_apply",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__ItemLibApplyWithPagination' */'/usr/src/app/src/pages/Goods/ItemLibApplyWithPagination'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "goodsMultiPackagingAudit",
                "path": "/Product/goods_multi_packaging_audit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Product__GoodsMultiPackagingAudit' */'/usr/src/app/src/pages/Product/GoodsMultiPackagingAudit'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "productSalesRank",
                "path": "/commodity_management/product_sales_rank",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Goods__ProductSalesRank' */'/usr/src/app/src/pages/Goods/ProductSalesRank'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "superAdminControl",
            "icon": "setting",
            "path": "/super_admin_control",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SuperAdminControl__Control' */'/usr/src/app/src/pages/SuperAdminControl/Control'), loading: LoadingComponent}),
            "authority": [
              "superadmin"
            ],
            "exact": true
          },
          {
            "name": "superAdminControls",
            "path": "/super_admin_control/controls",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SuperAdminControl__Controls' */'/usr/src/app/src/pages/SuperAdminControl/Controls'), loading: LoadingComponent}),
            "hideInMenu": true,
            "authority": [
              "superadmin"
            ],
            "exact": true
          },
          {
            "name": "superAdministrator",
            "icon": "control",
            "path": "/super_administrator",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SuperAdministrator' */'/usr/src/app/src/pages/SuperAdministrator'), loading: LoadingComponent}),
            "authority": [
              "superadmin"
            ],
            "exact": true
          },
          {
            "name": "transactionManagement",
            "icon": "wallet",
            "path": "/transaction_management",
            "authority": [
              "agency",
              "agencysub",
              "superadmin",
              "server",
              "business"
            ],
            "routes": [
              {
                "name": "order",
                "path": "/transaction_management/order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order' */'/usr/src/app/src/pages/Order'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "business"
                ],
                "exact": true
              },
              {
                "name": "orderDetail",
                "path": "/transaction_management/order/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Detail' */'/usr/src/app/src/pages/Order/Detail'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "business"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "orderDetailAlipay",
                "path": "/transaction_management/order/detail_alipay",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__DetailAlipay' */'/usr/src/app/src/pages/Order/DetailAlipay'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "business"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "abnormalOrder",
                "path": "/transaction_management/abnormal_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__AbnormalOrder' */'/usr/src/app/src/pages/Order/AbnormalOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "abnormalOrderHandler",
                "path": "/transaction_management/abnormal_order_handler",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__AbnormalOrderHandler' */'/usr/src/app/src/pages/Order/AbnormalOrderHandler'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "server"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "refundOrder",
                "path": "/transaction_management/refund_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__RefundOrder' */'/usr/src/app/src/pages/Order/RefundOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "refundOrderDetail",
                "path": "/transaction_management/refund_order/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__RefundOrder__Detail' */'/usr/src/app/src/pages/Order/RefundOrder/Detail'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "transactionBillPartitioned",
                "path": "/transaction_management/transaction_bill_partitioned",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__TransactionBillPartitioned' */'/usr/src/app/src/pages/Order/TransactionBillPartitioned'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "superadminOrder",
                "path": "/transaction_management/superadmin_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__superadminOrder' */'/usr/src/app/src/pages/Order/superadminOrder'), loading: LoadingComponent}),
                "authority": [
                  "superadmin",
                  "server"
                ],
                "exact": true
              },
              {
                "name": "repOrder",
                "path": "/transaction_management/rep_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__RepOrder' */'/usr/src/app/src/pages/Order/RepOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "server"
                ],
                "exact": true
              },
              {
                "name": "superadminOrderStatistic",
                "path": "/transaction_management/superadmin_order_statistic",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__superadminOrderStatistic' */'/usr/src/app/src/pages/Order/superadminOrderStatistic'), loading: LoadingComponent}),
                "authority": [
                  "superadmin"
                ],
                "exact": true
              },
              {
                "name": "agentOrderStatistic",
                "path": "/transaction_management/agent_order_statistic",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__AgentOrderStatistic' */'/usr/src/app/src/pages/Order/AgentOrderStatistic'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub",
                  "deliveryman",
                  "business"
                ],
                "exact": true
              },
              {
                "name": "superadminAbnormalOrder",
                "path": "/transaction_management/superadmin_abnormal_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__superadminOrder__AbnormalOrder' */'/usr/src/app/src/pages/Order/superadminOrder/AbnormalOrder'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "superadminAbnormalOrderList",
                "path": "/transaction_management/superadmin_abnormal_order_list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__superadminOrder__AbnormalOrderList' */'/usr/src/app/src/pages/Order/superadminOrder/AbnormalOrderList'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "orderDetail",
                "path": "/transaction_management/superadmin_order/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__Detail' */'/usr/src/app/src/pages/Order/Detail'), loading: LoadingComponent}),
                "authority": [
                  "superadmin",
                  "server"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "orderDetail",
                "path": "/transaction_management/superadmin_order/detail_alipay",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__DetailAlipay_superadmin_visionpay' */'/usr/src/app/src/pages/Order/DetailAlipay_superadmin_visionpay'), loading: LoadingComponent}),
                "authority": [
                  "superadmin",
                  "server"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "consumerOrder",
                "path": "/transaction_management/consumer",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__ConsumerOrder' */'/usr/src/app/src/pages/Order/ConsumerOrder'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "OrderAgentStatistic",
                "path": "/transaction_management/order_agent_statistic",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__OrderAgentStatistic' */'/usr/src/app/src/pages/Order/OrderAgentStatistic'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "wechatCCOrder",
                "path": "/transaction_management/wechat_cco_rder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Order__wechatCCOrder' */'/usr/src/app/src/pages/Order/wechatCCOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "server"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "rules",
            "icon": "filter",
            "path": "/rules",
            "authority": [
              "agency",
              "agencysub"
            ],
            "routes": [
              {
                "name": "priceRule",
                "path": "/rules/price_rule",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Rules__PriceRule' */'/usr/src/app/src/pages/Rules/PriceRule'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "priceDetail",
                "hideInMenu": true,
                "path": "/rules/price_rule/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Rules__PriceDetail' */'/usr/src/app/src/pages/Rules/PriceDetail'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "distributionRules",
                "path": "/rules/distribution_rules",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Rules__Distributionrules' */'/usr/src/app/src/pages/Rules/Distributionrules'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "theme",
            "icon": "setting",
            "path": "/theme",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Theme' */'/usr/src/app/src/pages/Theme'), loading: LoadingComponent}),
            "authority": [
              "server"
            ],
            "exact": true
          },
          {
            "name": "serverControl",
            "icon": "hdd",
            "path": "/server_control",
            "authority": [
              "server"
            ],
            "routes": [
              {
                "name": "control",
                "path": "/server_control/controls",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ServerControl__Controls' */'/usr/src/app/src/pages/ServerControl/Controls'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "dealer_control",
                "path": "/server_control/dealer_control",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ServerControl__DealerControl' */'/usr/src/app/src/pages/ServerControl/DealerControl'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "after_sale_staff_control",
                "path": "/server_control/after_sale_staff_control",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ServerControl__AfterSalePerson' */'/usr/src/app/src/pages/ServerControl/AfterSalePerson'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "simControl",
            "icon": "wifi",
            "path": "/sim_control",
            "authority": [
              "server"
            ],
            "routes": [
              {
                "name": "simFlowLimit",
                "path": "/sim_control/sim_flow_limit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__simControl__SimFlowLimit' */'/usr/src/app/src/pages/simControl/SimFlowLimit'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "simCardList",
                "path": "/sim_control/sim_card_list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__simControl__SimCardList' */'/usr/src/app/src/pages/simControl/SimCardList'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "simLogoutLog",
                "path": "/sim_control/sim_logout_log",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__simControl__SimLogoutLog' */'/usr/src/app/src/pages/simControl/SimLogoutLog'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "distribution",
            "icon": "shopping-cart",
            "path": "/distribution",
            "authority": [
              "agency",
              "agencysub"
            ],
            "routes": [
              {
                "name": "supplementRecordWithPagination",
                "path": "/distribution/supplement_record_with_pagination",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Distribution__SupplementRecordWithPagination' */'/usr/src/app/src/pages/Distribution/SupplementRecordWithPagination'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "authorizedEquipment",
                "path": "/distribution/authorizedequipment",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Distribution__Authorizedequipment' */'/usr/src/app/src/pages/Distribution/Authorizedequipment'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "deliveryman",
                "path": "/distribution/deliveryman",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Distribution__Deliveryman' */'/usr/src/app/src/pages/Distribution/Deliveryman'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "capitalCategory",
            "icon": "money-collect",
            "path": "/capital_category",
            "authority": [],
            "routes": [
              {
                "name": "withdrawalInformationByServer",
                "path": "/capital_category/withdrawal_information_by_server",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CapitalCategory__WithdrawalInformationByServer' */'/usr/src/app/src/pages/CapitalCategory/WithdrawalInformationByServer'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "withdrawalInformation",
                "path": "/capital_category/withdrawal_information",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CapitalCategory__WithdrawalInformation' */'/usr/src/app/src/pages/CapitalCategory/WithdrawalInformation'), loading: LoadingComponent}),
                "authority": [],
                "exact": true
              },
              {
                "name": "capitalSettlement",
                "path": "/capital_category/capitalsettlement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "capitalDetails",
                "path": "/capital_category/capitaldetails",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "withdrawal",
                "path": "/capital_category/withdrawal",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "capitalSettlementCheck",
                "path": "/capital_category/capitalsettlementcheck",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CapitalCategory__Capitalsettlementcheck' */'/usr/src/app/src/pages/CapitalCategory/Capitalsettlementcheck'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "withdrawalsuperadmincheck",
                "path": "/capital_category/withdrawalsuperadmincheck",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CapitalCategory__Withdrawalsuperadmincheck' */'/usr/src/app/src/pages/CapitalCategory/Withdrawalsuperadmincheck'), loading: LoadingComponent}),
                "authority": [
                  "superadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "charge",
            "icon": "transaction",
            "path": "/charge",
            "authority": [
              "agency",
              "superadmin",
              "platformadmin",
              "server"
            ],
            "routes": [
              {
                "name": "deviceRechargeOrder",
                "path": "/charge/device_recharge_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__DeviceRechargeOrder' */'/usr/src/app/src/pages/Charge/DeviceRechargeOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "superadmin"
                ],
                "exact": true
              },
              {
                "name": "devices",
                "path": "/charge/devices",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__Devices' */'/usr/src/app/src/pages/Charge/Devices'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              },
              {
                "name": "chargeMonthly",
                "path": "/charge/chargeMonthly",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__ChargeMonthly' */'/usr/src/app/src/pages/Charge/ChargeMonthly'), loading: LoadingComponent}),
                "authority": [
                  "server"
                ],
                "exact": true
              },
              {
                "name": "chargeDevices",
                "path": "/charge/chargeDevices",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__ChargeDevices' */'/usr/src/app/src/pages/Charge/ChargeDevices'), loading: LoadingComponent}),
                "authority": [
                  "server",
                  "agency",
                  "superadmin"
                ],
                "exact": true
              },
              {
                "name": "deviceRechargePackage",
                "path": "/charge/device_recharge_package",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__DeviceRechargePackage' */'/usr/src/app/src/pages/Charge/DeviceRechargePackage'), loading: LoadingComponent}),
                "authority": [
                  "superadmin"
                ],
                "exact": true
              },
              {
                "name": "identityLog",
                "path": "/charge/identity_log",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Charge__IdentityLog' */'/usr/src/app/src/pages/Charge/IdentityLog'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "memberCategory",
            "icon": "user",
            "path": "/member_category",
            "authority": [
              "agency",
              "agencysub",
              "superadmin"
            ],
            "routes": [
              {
                "name": "memberManage",
                "path": "/member_category/membermanage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MemberCategory__Membermanage' */'/usr/src/app/src/pages/MemberCategory/Membermanage'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "blacklist",
                "path": "/member_category/balcklist",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MemberCategory__Blacklist' */'/usr/src/app/src/pages/MemberCategory/Blacklist'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "memberManageProvider",
                "path": "/member_category/membermanage_provider",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MemberCategory__MembermanageProvider' */'/usr/src/app/src/pages/MemberCategory/MembermanageProvider'), loading: LoadingComponent}),
                "authority": [
                  "superadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "activity",
            "icon": "red-envelope",
            "path": "/activity",
            "authority": [
              "agency"
            ],
            "routes": [
              {
                "name": "secondHalfDiscount",
                "path": "/activity/second_half_discount",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Activity__SecondHalfDiscount' */'/usr/src/app/src/pages/Activity/SecondHalfDiscount'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "exact": true
              },
              {
                "name": "coupon",
                "path": "/activity/coupon",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Activity__Coupon' */'/usr/src/app/src/pages/Activity/Coupon'), loading: LoadingComponent}),
                "authority": [
                  "agency"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "workOrder",
            "icon": "shop",
            "path": "/work_order",
            "authority": [
              "platformadmin"
            ],
            "routes": [
              {
                "name": "modelWorkOrder",
                "path": "/work_order/model_work_order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WorkOrder__ModelWorkOrder' */'/usr/src/app/src/pages/WorkOrder/ModelWorkOrder'), loading: LoadingComponent}),
                "authority": [
                  "agency",
                  "agencysub"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "modelWorkOrderPlatform",
                "path": "/work_order/model_work_order_platform",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WorkOrder__ModelWorkOrderByPlatform' */'/usr/src/app/src/pages/WorkOrder/ModelWorkOrderByPlatform'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "ai",
            "icon": "GlobalOutlined",
            "path": "/ai",
            "authority": [
              "platformadmin"
            ],
            "routes": [
              {
                "name": "platform",
                "path": "/ai/platform",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Ai__Platform' */'/usr/src/app/src/pages/Ai/Platform'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "sku",
                "path": "/ai/sku",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Ai__Sku' */'/usr/src/app/src/pages/Ai/Sku'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "order",
                "path": "/ai/order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Ai__Order' */'/usr/src/app/src/pages/Ai/Order'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              },
              {
                "name": "statistic",
                "path": "/ai/statistic",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Ai__Statistic' */'/usr/src/app/src/pages/Ai/Statistic'), loading: LoadingComponent}),
                "authority": [
                  "platformadmin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "OrderVideo_OrderResult",
            "icon": "setting",
            "path": "/order_video_order_result",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderVideo_OrderResult' */'/usr/src/app/src/pages/OrderVideo_OrderResult'), loading: LoadingComponent}),
            "authority": [
              "auditor"
            ],
            "exact": true
          },
          {
            "name": "ps",
            "icon": "ScissorOutlined",
            "path": "/ps",
            "authority": [
              "ps",
              "ps_auditor"
            ],
            "routes": [
              {
                "name": "ps",
                "path": "/ps/ps_task",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ps' */'/usr/src/app/src/pages/ps'), loading: LoadingComponent}),
                "authority": [
                  "ps"
                ],
                "exact": true
              },
              {
                "name": "ps_audit",
                "path": "/ps/ps_audit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ps_audit' */'/usr/src/app/src/pages/ps_audit'), loading: LoadingComponent}),
                "authority": [
                  "ps_auditor",
                  "ps"
                ],
                "exact": true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
